import ExperienceItem from './ExperienceItem';

function Experience() {
  const experiences = [
    {
      position: "Software Engineering Intern",
      dateRange: "Jun 2026 - Aug 2026",
      company: "Capital One",
      location: "Richmond, VA",
      description: "Technology Internship Program (TIP) - Incoming Summer 2026",
      logoUrl: "/capitalone.png"
    },
    {
      position: "Technology Architect Intern",
      dateRange: "Jun 2025 - Aug 2025",
      company: "Voya Financial",
      location: "New York, NY",
      description: "I automated a manual process using Power Automate to efficiently handle approvals. I partnered with chief architects and wrote documentation so the automation could remain in use.",
      logoUrl: "/voya.png"
    },
    {
      position: "Software Engineer Intern",
      dateRange: "Mar 2025 - Jun 2025",
      company: "Quantum Pulse Consulting",
      location: "Detroit, MI",
      description: "I contributed to the development of a client-facing web application using React, Django, and PostgreSQL. I worked with a cross-functional Agile team to deliver features efficiently and iteratively.",
      logoUrl: "/qpc.jpg"
    },
    {
      position: "Undergraduate Researcher",
      dateRange: "Apr 2024 - May 2025",
      company: "New Jersey Institute of Technology",
      location: "Newark, NJ",
      description: "I conducted paid research developing interactive data visualizations of complex network graphs using Unity and C#. I also designed an independent study where I built a generative AI agent in VR.",
      logoUrl: "/njit.jpg"
    }
  ];

  return (
    <section className="section-wrap fade-up">
      <div className="mb-10 text-center">
        <p className="section-kicker">Career</p>
        <h2 className="section-title mt-2">Work Experience</h2>
      </div>

      <div className="mx-auto max-w-5xl space-y-5">
          {experiences.map((exp, index) => (
            <ExperienceItem
              key={index}
              index={index}
              position={exp.position}
              dateRange={exp.dateRange}
              company={exp.company}
              location={exp.location}
              description={exp.description}
              logoUrl={exp.logoUrl}
            />
          ))}
      </div>
    </section>
  );
}

export default Experience; 